import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { bySlug } from "../../data/salon";
import { useReveal, useScrollScrub } from "../../lib/motion";

export default function Editorial() {
  const scene = useScrollScrub();
  const copy = useReveal();
  const service = bySlug("bridal-package");

  return (
    <section className="edito" ref={scene}>
      <div className="edito__type" aria-hidden="true">
        <span className="edito__word">BRIDAL</span>
      </div>

      <div className="wrap wrap--wide edito__inner">
        <div className="edito__media">
          <Photo src={service.photo} ratio="3 / 4" scrub tint="warm" className="edito__ph" />
          <Photo src="look-08" ratio="1 / 1" scrub className="edito__ph edito__ph--inset" />
        </div>

        <div className="edito__copy reveal" ref={copy}>
          <span className="eyebrow eyebrow--violet">THE BRIDAL SUITE</span>

          <h2 className="edito__title">
            برای مهم‌ترین روز،
            <br />
            یک تیم کامل
          </h2>

          <p>
            از جلسه تست تا لحظه‌ای که از سالن بیرون می‌روی، یک تیم اختصاصی
            کنارت است؛ گریم، شینیون، ناخن و مراقبت پوست، همه در یک برنامه
            که از شش ماه قبل چیده می‌شود.
          </p>

          <ul className="edito__list">
            {service.includes.map((x) => <li key={x}>{x}</li>)}
          </ul>

          <Link to="/services/bridal-package" className="btn btn--light">
            دیدن پکیج عروس
          </Link>
        </div>
      </div>
    </section>
  );
}
